export const h4l_onboarding = {
  mfaRequired: true,
  mfaAdobeTenantSection: 'cvscare_onboarding',
  adobeFlowName: 'cvscare_onboarding',
  source: 'H4L',
  title: 'Enter your information',
  description: 'We’ll look for your records.',
  addrTitle: 'Enter your address',
  addrDescription: 'We’ll look for your pharmacy records.',
  showCardLink: false,
  showDemoLink: false
};

export const caregiving_access = {
  mfaRequired: false,
  adobeFlowName: 'caregiving_access',
  source: 'Caregiving',
  title: 'Who are you \ncaring for?',
  description: 'We’ll look for their records.',
  addrTitle: 'Enter their address',
  addrDescription: 'We’ll look for this person’s pharmacy records.',
  showCardLink: true,
  showDemoLink: false
};
export const ent_caregiving_access = {
  mfaRequired: false,
  adobeFlowName: 'caregiving_access',
  source: 'ENTERPRISE_CAREGIVING',
  title: 'Who are you \ncaring for?',
  description: 'We’ll look for their records.',
  addrTitle: 'Enter their address',
  addrDescription: 'We’ll look for this person’s pharmacy records.',
  showCardLink: true,
  showDemoLink: false
};
export const PHARMACY = {
  mfaRequired: true,
  mfaAdobeTenantSection: 'cvscare_onboarding',
  adobeFlowName: 'cvscare_onboarding',
  source: 'PHARMACY',
  title: 'Enter your information',
  description: 'We’ll look for your records.',
  addrTitle: 'Enter your address',
  addrDescription: 'We’ll look for your pharmacy records.',
  showCardLink: true,
  showDemoLink: true
};

export const DOORDASH = {
  mfaRequired: true,
  mfaAdobeTenantSection: 'cvscare_onboarding',
  adobeFlowName: 'cvscare_onboarding',
  source: 'OMNI_LOA2',
  title: 'Enter your information',
  description: 'We’ll look for your records.',
  addrTitle: 'Enter your address',
  addrDescription: 'We’ll look for your pharmacy records.',
  showCardLink: true,
  showDemoLink: true,
  returnUrl: '/account/onboarding/tie?',
  continueUrl: '/account/onboarding/data-preferences?',
  consumerName: 'DoorDash',
  keepQueryAfterLookup: true,
  isThirdParty: true
};

export const classic = {
  mfaRequired: true,
  mfaAdobeTenantSection: 'registration',
  adobeFlowName: 'registration',
  source: 'unified_registration',
  title: 'Let\'s get started',
  description: '',
  addrTitle: 'Enter your address',
  addrDescription: '',
  showCardLink: false,
  showDemoLink: false
};

export const healthy_caregiver = {
  mfaRequired: true,
  mfaAdobeTenantSection: 'cvscare_onboarding',
  adobeFlowName: 'cvscare_onboarding',
  source: 'HEALTHY_CAREGIVER',
  title: 'Enter your information',
  description: 'We’ll look for your records.',
  addrTitle: 'Enter your address',
  addrDescription: 'We’ll look for your pharmacy records.',
  showCardLink: true,
  showDemoLink: true
};

export const forgot_username = {
  mfaRequired: true,
  adobeFlowName: 'forgot_user',
  source: 'forgot_username',
  title: 'We just need to confirm it\'s you',
  description: 'Enter your information to help us locate your account.',
  addrTitle: 'Enter your address',
  addrDescription: '',
  showCardLink: false,
  showDemoLink: false,
  returnUrl: '/account-login/view-username',
  keepQueryAfterLookup: false
};

export const rx_merge = {
  mfaRequired: true,
  mfaAdobeTenantSection: 'rx_merge', //TODO: update with analytics spec
  adobeFlowName: 'rx_merge', //TODO: update with analytics spec
  source: 'PHARMACY',
  flow: 'rx_merge',
  title: 'Enter your information',
  description: 'We’ll look for your records.',
  showCardLink: false,
  showDemoLink: false,
  returnUrl: '/pharmacy/rx/prescriptions?flow=rx_merge'
};

export const registered = {
  mfaRequired: true,
  adobeFlowName: 'registration',
  source: 'unified_registration',
  title: 'Let\'s get started',
  description: '',
  addrTitle: 'Enter your address',
  addrDescription: '',
  showCardLink: false,
  showDemoLink: false,
  returnUrl: '/account-login/welcome-back'
};
export const unlock_account = {
  mfaRequired: true,
  adobeFlowName: 'unlock_account',
  source: 'UNLOCK_ACCOUNT',
  title: 'Enter your information',
  description: 'We’ll look for your records.',
  showCardLink: false,
  showDemoLink: false,
  returnUrl: '/account-login/reset-password'
};

export const ent_self = {
  mfaRequired: true,
  mfaAdobeTenantSection: 'cvscare_onboarding',
  adobeFlowName: 'cvscare_onboarding',
  source: 'H4L',
  title: 'Enter your information',
  description: 'We’ll look for your records.',
  addrTitle: 'Enter your address',
  addrDescription: 'We’ll look for your pharmacy records.',
  showCardLink: true,
  showDemoLink: false
};
